// pages/Create.tsx
import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IMaterialGroup from '../interfaces/IMaterialGroup';
import Layout from '~/components/Layout';

export default function Create() {
  const { register, handleSubmit, control, setValue: setFormValue } = useForm<IMaterialGroup>();
  const fields = [
    { name: 'name', type: 'string' },
  ];

  return (
    <Layout marginLayout={true}>
      <CrudCreate
        model={'material-group'}
        fields={fields}
        register={register}
        handleSubmit={handleSubmit}
        control={control}
        messageSuccess={'Material group successfully created!'}
        title={'Add material group'}
        subheader={'Add material group'}
        setFormValue={setFormValue}
      />
    </Layout>
  );
}